'use client';

import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/shared/utils/cn';
import { Button } from '@/shared/components/primitives/button';

type FormSubmitProps = ComponentPropsWithoutRef<'button'> & {
  width?: string;
};

export const FormSubmit = forwardRef<HTMLButtonElement, FormSubmitProps>(
  ({ className, children, width = 'min-w-52', ...props }, ref) => (
    <Button ref={ref} className={cn('block', width, className)} type='submit' {...props}>
      {children}
    </Button>
  ),
);

FormSubmit.displayName = 'FormSubmit';
